<style scoped lang="less">
  @import '../../../../style/common/variable';
  #map3d{position: relative;width:100vw;height:100vh}
  .head-img{position: absolute;z-index: 99;
    img{width: 100%;height: 100%;}
  }
  .layer-tree{position: absolute;width: 16%;height:89.8%;top:8.8%;left:.7%;z-index: 99;background-color: rgba(34, 85, 172, 0.88);border-radius: 6px;}
  /deep/.cxe-location-bar{position: absolute;display:flex;flex-wrap: wrap;left:76.5%;bottom:12px;overflow: hidden;width: 300px;height: 20px;border: solid 1px #6491e0;background: rgba(34,85,172,.88);}
  /deep/.camera-location{display: none;}
  .all-country{position: absolute;bottom: 0;left: 24%;width: 52%;height: 6.6%;background-image: url('/static/images/kyyztdb.png');background-repeat:no-repeat;z-index: 99;background-size: contain;}
  .country-box{display: flex;justify-content: space-evenly;width: 89%;margin: 0 4%;}
  .country{padding-top: 8px;width:80px;cursor: pointer;
    .country-name{color: #fff;}
  }
  .country:hover{background: linear-gradient(to top,rgba(122, 233, 255, 0.6),rgba(0,0,0, 0))}
  .country.check{background: linear-gradient(to top,rgba(122, 233, 255, 0.6),rgba(0,0,0, 0))}
  .mode-switch{display: flex;flex-wrap: wrap;align-content: center;justify-content: space-around;position: absolute;top: 12px;right: 19%;width:40px;height:40px;background-color: rgba(34, 85, 172, 0.88);border-radius: 4px;border: solid 1px #6491e0;z-index: 99;
  }
  .mode-box{display:flex;width: 40px;height: 40px;cursor: pointer;align-content: space-around;flex-wrap: wrap;justify-content: space-around;
    img{width: 22px;height: 22px;}
  }
  .tool:hover{background-color: #2080ff;}
  .tool.check {background-color: #2080ff;}
  .legend{position: absolute;bottom: 12px;right: .7%;z-index: 99;background-color: rgba(34, 85, 172, 0.88);border-radius: 4px;border: solid 1px #6491e0;}
  .maptype{position: relative;width: 102px; height: 75px; border-radius: 2px; cursor: pointer; margin: 5px;border:solid 2px #fff;z-index: 99;}
  .maptype.check {border:solid 2px #7ae9ff;}

  .typeName {position: absolute; right: 0;float:right;color: white;background: #c4c4c4;}
  .typeName.check {background: #7ae9ff;}
  .toolbar{display: flex;flex-wrap: wrap;align-content: center;justify-content: space-around;position: absolute;top: 12px;right: .7%;width:340px;height:40px;background-color: rgba(34, 85, 172, 0.88);border-radius: 4px;border: solid 1px #6491e0;z-index: 99;}
  .tool{display:flex;width: 40px;height: 40px;cursor: pointer;align-content: space-around;flex-wrap: wrap;justify-content: space-around;
    img{width: 22px;height: 22px;}
  }
  .tool:hover{background-color: #2080ff;}
  .tool.check {background-color: #2080ff;}
  .position{position: absolute; top: 170px; right: -198px;z-index: 99;}
  .markbar{display: flex;border-radius: 5px;overflow: hidden;position: absolute;right: 6.9%;top:55px;z-index: 99;}
  .cross{padding: 5px;width: 45px;height: 45px;background-color: rgba(34, 85, 172, 0.88);border: none; border-radius: 0; margin: 0;
    span{display: flex;flex-direction: column; color: #ffffff;;
      i{font-size: 24px;}
    }
  }
  .cross:focus{background: #2080ff !important;
    span{color: #fff}
  }
  .cross:hover{background: #2080ff !important;
    span{color: #fff}
  }
  .label{position: absolute; top: 324px; right: -200px;z-index: 99;}
  .settrans{position: absolute; top: 324px; right: -200px;z-index: 99;}
  .searchbox{position: absolute; top: 209px; right: -97px;z-index: 99;}
  .searchresult{position: absolute; bottom: -92px; right: 135px;z-index: 99;}
  .legends{position: absolute; top: 278px; right: -182px;z-index: 99;}
  // .minshow{position: absolute; bottom: 1px; left: 400px;z-index: 99;width: 40px;height: 40px;cursor: pointer;background-color: rgba(34, 85, 172, 0.88);}
  .minshow{position: absolute; bottom: 5px; left: 375px;z-index: 99;display:flex;width: 40px;height: 40px;cursor: pointer;align-content: space-around;flex-wrap: wrap;justify-content: space-around;;background-color: rgba(34, 85, 172, 0.88);
    img{width: 30px;height: 30px;}
  }
  .identifying{position: absolute;display: flex;bottom: 40px;right: 140px;z-index: 99;
    span{color: #E69A36;margin-left: 10px;font-weight: bold;}
  }
  @media screen and (min-width: @max-screen){

  }
  @media screen and (max-width: @max-screen){
    .all-country{display: none;}
    .mode-switch{display: none;}
    .legend{display: none;}
    .toolbar{display: none;}
    /deep/.cxe-location-bar{display: none;}
    .identifying{display: none;}
    .layer-tree{width: 43%; height: 78%; left: 0.2%}
    /deep/.custom-tree-node{font-size: .12rem;}
    /deep/.el-tree-node__content{
      .el-checkbox__label{font-size: .12rem;}
    }
  }
</style>
<template>
  <div>
    <div id="map3d"  element-loading-text="加载中" element-loading-background="rgba(30,59,91, 0.8)">
      <div class="head-img">
        <img src="static/images/kyyztdhl.png" alt="">
      </div>
      <div class="layer-tree">
        <LayerManager @changeLayer="changeLayer" @SetLayerTrans="SetLayerTrans" ref="layertree"></LayerManager>
      </div>
      <div class="all-country">
        <div class="country-box">
          <div v-for="item in this.allCountry" :key="item" class="country" @click="onClickCountry(item)" :class="{check: item.isCheck}">
            <img :src="item.url" alt="">
            <div class="country-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="mode-switch">
          <div v-for="item in this.layerSwitch" :key="item" class="mode-box" @click="onClickSwitch(item)" :class="{check: item.isCheck}" >
              <img :src="item.isCheck === true ? item.imgUrl : item.imgUrls" alt="">
          </div>
      </div>
      <div class="legend">
        <div class="maptype" :class="{check: item.isCheck}" v-for="item in btnList" :key="item" :style="{'background': `url(${item.imgUrl})`, 'background-size': '100% 100%'}" @click="onClick(item)">
          <span class="typeName" :class="{check: item.isCheck}">{{item.title}}</span>
        </div>
      </div>
      <div class="toolbar">
        <div class="tool" :class="{check: item.isCheck}" v-for="item in tools" :key="item" @click="onClickTool(item)">
          <el-tooltip class="item" effect="dark" :content="item.title" placement="bottom">
            <img :src="item.url" alt="">
          </el-tooltip>
        </div>
      </div>
      <div class="markbar" v-if="markflag">
        <el-tooltip class="item" effect="dark" :content="group.label" placement="bottom" plain v-for="(group, index) in markdata" :key="index">
          <el-button type="primary" class="cross" @click="onMeasure(group, index)">
            <span>
              <i :class="group.icon"></i>
            </span>
          </el-button>
        </el-tooltip>
      </div>
      <!-- 工具栏-查询 -->
      <SearchBox class="searchbox" ref="searchbox" @setSearchData="setSearchData" @setSearchDatas="setSearchDatas" @onMeasures="setMeasure"></SearchBox>
       <!-- 工具栏-查询结果 -->
       <SearchResult class="searchresult" ref="searchresult" :searchData="this.searchData" @positionPoint="positionPoint" @delPos="delPos" @minPos="minPos"></SearchResult>
      <!-- 工具栏-定位 -->
      <PositionBox class="position" ref="position"></PositionBox>
      <!-- 工具栏-标注-点 -->
      <LabelPoint class="label" ref="label" @drawPoint="drawPoint" @delPoint="delPoint"></LabelPoint>
      <!-- 工具栏-图例 -->
      <Legend class="legends" ref="legend"></Legend>
      <!-- 工具栏-透明度设置 -->
      <SetTrans class="settrans" ref="settrans" :layerdata="treeData"></SetTrans>
      <div class="minshow" v-if="minIcon" @click="clickMinIcon">
        <img src="static/images/tools/最大化.svg" alt="">
      </div>
      <div class="identifying">
        <img src="https://api.tianditu.gov.cn/v4.0/image/logo.png" alt="">
        <span>GS(2025)1508号 - 甲测资字11110974</span>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import * as turf from '@turf/turf'
import LayerManager from '../kyyzt/LayerManager'
import PositionBox from './PositioningBox'
import LabelPoint from './LabelPoint'
import SetTrans from './SetTrans'
import SearchBox from './SearchBox.vue'
import SearchResult from './SearchResult.vue'
import Legend from './Legend.vue'
import GeoQryBySvr from '@/plugins/app/assembly/kyxxyzt/GeoQryBySvr.js'
import OmpBase from '@/plugins/app/assembly/kyxxyzt/OmpBase'
import Popup from '@/plugins/app/assembly/kyxxyzt/popup/DpIndex'
let terrainLayer

let handlerClick = null
let drawLayerArea, drawLayerLine, drawLayerPoint, drawLine, drawArea, drawPoint, point, polygon
export default {
  components: {LayerManager, PositionBox, LabelPoint, SetTrans, SearchBox, SearchResult, Legend},
  props: [],
  mixins: [],
  data()
  {
    return {
      // 各个国家
      allCountry: [
        {url: 'static/images/allcountry/东盟.png', isCheck: true, name: '东盟', value: 0, center: [102.289, 16.284]},
        {url: 'static/images/allcountry/文莱.png', isCheck: false, name: '文莱', value: 1, center: [114.622, 4.659]},
        {url: 'static/images/allcountry/柬埔寨.png', isCheck: false, name: '柬埔寨', value: 2, center: [105.14, 13.22]},
        {url: 'static/images/allcountry/印度尼西亚.png', isCheck: false, name: '印度尼西亚', value: 3, center: [127.23, -0.035]},
        {url: 'static/images/allcountry/马来西亚.png', isCheck: false, name: '马来西亚', value: 4, center: [114.23, 3.51]},
        {url: 'static/images/allcountry/菲律宾.png', isCheck: false, name: '菲律宾', value: 5, center: [123.67, 12.52]},
        {url: 'static/images/allcountry/新加坡.png', isCheck: false, name: '新加坡', value: 6, center: [103.377, 0.974]},
        {url: 'static/images/allcountry/泰国.png', isCheck: false, name: '泰国', value: 7, center: [100.72, 17.25]},
        {url: 'static/images/allcountry/缅甸.png', isCheck: false, name: '缅甸', value: 8, center: [96.07, 22.83]},
        {url: 'static/images/allcountry/越南.png', isCheck: false, name: '越南', value: 9, center: [107.10, 17.29]},
        {url: 'static/images/allcountry/老挝.png', isCheck: false, name: '老挝', value: 10, center: [105.08, 17.47]}
      ],
      // 默认底图
      btnList: [
        {title: '地形底图', isCheck: false, imgUrl: 'static/index/地形图.jpg'},
        {title: '矢量底图', isCheck: false, imgUrl: 'static/index/矢量图.png'},
        {title: '卫星底图', isCheck: true, imgUrl: 'static/index/卫星图.png'}
      ],
      // 2D 3D数据
      layerSwitch: [
        {isCheck: true, imgUrl: 'static/images/tools/3D.svg', imgUrls: 'static/images/tools/2D.svg'}
      ],
      // 工具栏
      tools: [
        {url: 'static/images/tools/属性查看.svg', isCheck: false, title: '属性查看'},
        {url: 'static/images/tools/搜索.svg', isCheck: false, title: '搜索'},
        {url: 'static/images/tools/定位.svg', isCheck: false, title: '定位'},
        {url: 'static/images/tools/标注.svg', isCheck: false, title: '标注'},
        {url: 'static/images/tools/透明度.svg', isCheck: false, title: '透明度'},
        {url: 'static/images/tools/图例.svg', isCheck: false, title: '图例'},
        {url: 'static/images/tools/复位.svg', isCheck: false, title: '复位'},
        {url: 'static/images/tools/清除.svg', isCheck: false, title: '清除'}
      ],
      markflag: false, //标注工具条是否显示
      //标注工具条
      markdata:
      [
        {icon: 'iconfont icon-double-circle-full', label: '点', title: 'Point', function: 'Mark'},
        {icon: 'iconfont icon-icon-line-graph', label: '线', title: 'LineString', function: 'easureMent'},
        {icon: 'iconfont icon-duobianxing', label: '面', title: 'area', function: 'easureMent'}
      ],
      pointData: {},
      draw: null,
      isatts: false,
      treeData: [], // 勾选中树图层数据
      clickfeaturesPromise: {},
      searchData: [],
      kjfsData: [],
      SjgxDet: [], // 数据共享数据
      sjgxFld: [],
      metadata: [],
      layerHeight: [],
      minIcon: false,
      layerData: ''
    }
  },
  mounted()
  {
    this.init()
    // this.initOgc()
    this.getSjgxFld()
    this.CesiumEventClick()
  },
  methods:
  {
    // 测试加载wmts图层
    initOgc()
    {
      let _matrixIds = ['EPSG:4326:0', 'EPSG:4326:1', 'EPSG:4326:2', 'EPSG:4326:3', 'EPSG:4326:4', 'EPSG:4326:5', 'EPSG:4326:6', 'EPSG:4326:7', 'EPSG:4326:8', 'EPSG:4326:9', 'EPSG:4326:10',
        'EPSG:4326:11', 'EPSG:4326:12', 'EPSG:4326:13', 'EPSG:4326:14', 'EPSG:4326:15', 'EPSG:4326:16', 'EPSG:4326:17', 'EPSG:4326:18', 'EPSG:4326:19', 'EPSG:4326:20', 'EPSG:4326:21'
      ]
      let wmsLayer = new window.cxe.ImageryLayer('wmts', {
        url: 'http://192.168.2.157/zgis/mapserver/zgis/gwc/service/wmts',
        layer: 'zgis:地质体',
        style: '',
        format: 'image/png',
        tileMatrixSetID: 'EPSG:4326',
        tileMatrixLabels: _matrixIds,
        // subdomains: _matrixIds,
        tilingScheme: new window.Cesium.GeographicTilingScheme({
          numberOfLevelZeroTilesX: 2,
          numberOfLevelZeroTilesY: 1
        })
      })
      Viewer.layers.addImageryLayer(wmsLayer)
    },
    init(container)
    {
      this.viewer = new window.cxe.Viewer('map3d', {
        contextOptions: {
          webgl: {
            alpha: true,
            depth: false,
            stencil: true,
            antialias: true,
            premultipliedAlpha: true,
            preserveDrawingBuffer: true,
            failIfMajorPerformanceCaveat: true
          },
          allowTextureFilterAnisotropic: true
        }
      })
      window.Viewer = this.viewer
      this.viewer.scene.globe.depthTestAgainstTerrain = true
      this.vectorLayer = new window.cxe.ImageryLayer('tdt', {
        style: 'img',
        key: '569737ea36171685d686b54ce079a49d',
        show: true
      })
      this.viewer.layers.addImageryLayer(this.vectorLayer)
      this.ompBase = new OmpBase({ viewer: this.viewer })
      this.LoadNoteLayer()
      // 添加经纬度信息
      Viewer.stateBar.enable = true
      // 画点图层
      let pointLayer = new window.cxe.VectorLayer('pointLayer')
      Viewer.layers.addLayer(pointLayer)
      // 画点图层
      let polygonLayer = new window.cxe.VectorLayer('polygonLayer')
      Viewer.layers.addLayer(polygonLayer)
      this.setFlytoPos()
    },
    // 设置默认飞行经纬度地址
    setFlytoPos(val)
    {
      Viewer.camera.flyTo({
        destination: window.Cesium.Cartesian3.fromDegrees(102.289, 16.284, 1485110),
        duration: 5
      })
    },
    // 加载天地图注记
    LoadNoteLayer()
    {
      let baseLayerzj = new window.cxe.ImageryLayer('tdt', {
        style: 'cva',
        key: '569737ea36171685d686b54ce079a49d'
      })
      Viewer.layers.addImageryLayer(baseLayerzj)
    },
    /**
     * 按钮点击响应函数
     * @method
     * @param   {Object}   btn   按钮属性对象
     */
    onClick(btn)
    {
      this.btnList.forEach(item =>
      {
        item.isCheck = (item.title === btn.title) ? !item.isCheck : false
      })
      this.vectorLayer.show = !btn.isCheck
      if (btn.title === '矢量底图')
      {
        if (btn.isCheck === true)
        {
          if (this.wxLayer && this.wxLayerZj)
          {
            this.wxLayer.show = false
            this.wxLayerZj.show = false
          }
          this.slLayer = new window.cxe.ImageryLayer('tdt', {
            style: 'vec',
            key: '569737ea36171685d686b54ce079a49d',
            show: btn.isCheck
          })
          this.slLayer_zj = new  window.cxe.ImageryLayer('tdt', {
            style: 'cva',
            key: '569737ea36171685d686b54ce079a49d',
            show: btn.isCheck
          })
          this.viewer.layers.addImageryLayer(this.slLayer)
          this.viewer.layers.addImageryLayer(this.slLayer_zj)
          Viewer.imageryLayers.lowerToBottom(this.slLayer.delegate)
          Viewer.imageryLayers.lowerToBottom(this.slLayer_zj.delegate)
        }
        else
        {
          this.slLayer.show = false
          this.slLayer_zj.show = false
        }
      }
      else if (btn.title === '卫星底图')
      {
        if (btn.isCheck === true)
        {
          if (this.slLayer && this.slLayer_zj)
          {
            this.slLayer.show = false
            this.slLayer_zj.show = false
          }
          this.wxLayer = new window.cxe.ImageryLayer('tdt', {
            style: 'img',
            key: '569737ea36171685d686b54ce079a49d',
            show: btn.isCheck
          })
          this.wxLayerZj = new window.cxe.ImageryLayer('tdt', {
            style: 'cva',
            key: '569737ea36171685d686b54ce079a49d',
            show: btn.isCheck
          })
          this.viewer.layers.addImageryLayer(this.wxLayer)
          this.viewer.layers.addImageryLayer(this.wxLayerZj)
          Viewer.imageryLayers.lowerToBottom(this.wxLayer.delegate)
          Viewer.imageryLayers.lowerToBottom(this.wxLayerZj.delegate)
        }
        else
        {
          this.wxLayer.show = false
          this.wxLayerZj.show = false
        }
      }
      else
      {
        // 获取屏幕中心点
        let center = new window.Cesium.Cartesian2(Viewer.canvas.clientWidth / 2, Viewer.canvas.clientHeight / 2)
        // 屏幕坐标转换经纬度坐标
        let jwcoor = this.ompBase.screenToLng(center)
        if (btn.isCheck === true)
        {
          this.vectorLayer.show = btn.isCheck
          // 加载地形
          this.initTer(jwcoor)
        }
        else
        {
          Viewer.layers.removeTerrain(terrainLayer)
          Viewer.camera.flyTo({
            destination: window.Cesium.Cartesian3.fromDegrees(jwcoor[0], jwcoor[1], 1485110),
            duration: 4
          })
        }
      }
    },
    // 点击图层树数据
    changeLayer(val)
    {
      if (val.checked === true && val.node.glid !== 0)
      {
        // 根据关联数据共享字段查询数据
        this.getSjDetails(val.node.glsjgx)
        // 对勾选的树图层节点进行处理
        this.treeData.push({url: val.node.url, layer: val.node.layer, title: val.node.namec, namec: val.node.namec, legendImg: val.node.legendurl, showlevel: val.node.showlevel})
        this.treeData = this.treeData.filter((item, index) =>
        {
          let temArr = []
          this.treeData.forEach(item2 => temArr.push(item2.layer))
          return temArr.indexOf(item.layer) === index
        })
        // 判断图层类型是wms还是wmts并加载
        if (val.node.maptype === 'WMS')
        {
          let parameters = {}
          if (val.node.filter)
          {
            parameters = {
              service: 'WMS',
              format: 'image/png',
              transparent: true,
              srs: 'EPSG:4326',
              CQL_FILTER: val.node.filter
            }
          }
          else
          {
            parameters = {
              service: 'WMS',
              format: 'image/png',
              transparent: true,
              srs: 'EPSG:4326'
            }
          }
          let wmsLayer = new window.cxe.ImageryLayer('wms', {
            url: val.node.url,
            layers: val.node.layer,
            name: val.node.namec,
            parameters
          })
          // 添加排序
          wmsLayer.delegate.showlevel = val.node.showlevel
          Viewer.layers.addImageryLayer(wmsLayer)
        }
        else if (val.node.maptype === 'WMTS')
        {
          let _matrixIds = ['EPSG:4326:0', 'EPSG:4326:1', 'EPSG:4326:2', 'EPSG:4326:3', 'EPSG:4326:4', 'EPSG:4326:5', 'EPSG:4326:6', 'EPSG:4326:7', 'EPSG:4326:8', 'EPSG:4326:9', 'EPSG:4326:10',
            'EPSG:4326:11', 'EPSG:4326:12', 'EPSG:4326:13', 'EPSG:4326:14', 'EPSG:4326:15', 'EPSG:4326:16', 'EPSG:4326:17', 'EPSG:4326:18', 'EPSG:4326:19', 'EPSG:4326:20', 'EPSG:4326:21'
          ]
          let wmsLayer = new window.cxe.ImageryLayer('wmts', {
            url: val.node.geoweburl,
            layer: val.node.layer,
            style: '',
            format: 'image/png',
            tileMatrixSetID: 'EPSG:4326',
            tileMatrixLabels: _matrixIds,
            // subdomains: _matrixIds,
            tilingScheme: new window.Cesium.GeographicTilingScheme({
              numberOfLevelZeroTilesX: 2,
              numberOfLevelZeroTilesY: 1
            })
          })
          // 添加排序
          wmsLayer.delegate.showlevel = val.node.showlevel
          Viewer.layers.addImageryLayer(wmsLayer)
        }
        // let layerSort = Viewer.imageryLayers._layers
        // layerSort = this.bubbleSortByProperty(layerSort, 'showlevel')
      }
      else
      {
        if (val.checkild === false)
        {
          this.treeData = this.treeData.filter(item => item.layer !== val.node.layer)
          if (val.node.maptype === 'WMS')
          {
            Viewer.imageryLayers._layers.filter(item => item.imageryProvider.layers === val.node.layer).forEach(items =>
            {
              Viewer.imageryLayers.remove(items)
            })
          }
          else if (val.node.maptype === 'WMTS')
          {
            Viewer.imageryLayers._layers.filter(item => item.imageryProvider._layer === val.node.layer).forEach(items =>
            {
              Viewer.imageryLayers.remove(items)
            })
          }
        }
      }
      this.$refs.legend.getLegendData(this.treeData)
    },
    // 冒泡排序修改图层显示顺序
    bubbleSortByProperty(array, property)
    {
      const length = array.length
      for (let i = 0; i < length - 1; i++)
      {
        for (let j = 0; j < length - 1 - i; j++)
        {
          if (array[j][property] < array[j + 1][property])
          {
            const temp = array[j]
            array[j] = array[j + 1]
            array[j + 1] = temp
          }
        }
      }

      return array
    },
    // 树右键点击设置图层透明度
    SetLayerTrans(val)
    {
      // console.log(val)
      this.$refs.settrans.closePul()
    },
    // 点击切换国家数据
    onClickCountry(val)
    {
      Viewer.camera.flyTo({
        destination: window.Cesium.Cartesian3.fromDegrees(val.center[0], val.center[1], 1485110),
        duration: 4
      })
      this.allCountry.forEach(item =>
      {
        item.isCheck = (item.name === val.name) ? !item.isCheck : false
      })
      Viewer.imageryLayers._layers.filter(item => item.imageryProvider.url.indexOf('zgis') !== -1).forEach(items =>
      {
        Viewer.imageryLayers.remove(items)
      })
      this.treeData = []
      this.$refs.settrans.close()
      this.$refs.layertree.layerListname = val.name === '东盟' ? '总览' : val.name
      this.$refs.layertree.getCountryLayer(val)
    },
    // 点击切换2D 3D
    onClickSwitch(val)
    {
      this.setFlytoPos()
      this.layerSwitch[0].isCheck = !this.layerSwitch[0].isCheck
      if (val.isCheck === true)
        this.viewer.scene.screenSpaceCameraController.tiltEventTypes = [2, 4, {eventType: 0, modifier: 1}, {eventType: 0, modifier: 1}]
      else
        this.viewer.scene.screenSpaceCameraController.tiltEventTypes = []
    },
    // 点击工具栏
    onClickTool(val)
    {
      this.clearDraw()
      this.clearClick()
      this.destroyPop()
      this.tools.forEach(item =>
      {
        item.isCheck = (item.title === val.title) ? !item.isCheck : false
      })
      switch (val.title)
      {
      case '搜索': this.$refs.searchbox.showLP(); this.$refs.position.closePul(false); this.isAtts = false; this.markflag = false; this.$refs.legend.closePul(false); this.$refs.label.closeBox(false)
        break
      case '定位': this.$refs.position.showLP(); this.$refs.searchbox.closePul(false); this.isAtts = false; this.markflag = false; this.$refs.legend.closePul(false); this.$refs.label.closeBox(false)
        break
      case '标注': this.markflag = !this.markflag; this.isAtts = false; this.$refs.position.closePul(false); this.$refs.searchbox.closePul(false); this.$refs.legend.closePul(false); this.$refs.label.closeBox(false)
        break
      case '透明度': this.$refs.settrans.closePul(); this.isAtts = false; this.$refs.searchbox.closePul(false); this.$refs.position.closePul(false); this.markflag = false
        break
      case '图例': this.$refs.legend.showLP(); this.isAtts = false; this.$refs.position.closePul(false); this.$refs.searchbox.closePul(false);  this.markflag = false; this.$refs.label.closeBox(false)
        break
      case '属性查看': this.showAtts(); this.$refs.searchbox.closePul(false); this.$refs.position.closePul(false); this.markflag = false
        break
      case '复位': this.setFlytoPos(); this.isAtts = false
        break
      case '清除': this.clearDraw(); this.destroyPop(); this.clearClick(); this.delPos(); this.$refs.searchbox.closePul(false); this.$refs.position.closePul(false); this.markflag = false
        break
      }
    },
    // 加载默认地形
    initTer(jwcoor)
    {
      let terInfo = {
        params: {
          lng: jwcoor[0],
          lat: jwcoor[1],
          alt: 8000,
          heading: 12.619825649805156,
          pitch: -20.400461818215376,
          roll: 360
        },
        url: 'https://elevation3d.arcgis.com/arcgis/rest/services/WorldElevation3D/Terrain3D/ImageServer'
      }
      terrainLayer = new window.cxe.TerrainLayer('t_arcgis', {
        url: terInfo.url
      })
      Viewer.layers.addTerrain(terrainLayer)
      Viewer.flyToPos(terInfo.params)
    },
    // 绘制更新的回调：{graph, event, success}
    drawUpdate(args)
    {},
    // 绘制完成的回调
    drawFinish(args)
    {
      this.kjfsData = []
      if (args.graph.type === 'point')
      {
        let point = new window.cxe.Billboard({lng: args.graph.position.lng, lat: args.graph.position.lat, alt: args.graph.position.alt}, this.pointData.radio)
        point.size = [30, 30]
        point.setStyle({
          disableDepthTestDistance: 1 / 0
        })
        let label = new window.cxe.Label({ lng: args.graph.position.lng, lat: args.graph.position.lat, alt: args.graph.position.alt }, this.pointData.name)
        label.setStyle({
          heightReference: window.Cesium.HeightReference.NONE,
          showBackground: true,
          pixelOffset: new window.Cesium.Cartesian2(0, 20),
          fillColor: window.Cesium.Color.AZURE,
          backgroundColor: new window.Cesium.Color(0, 0, 0, 0.7),
          disableDepthTestDistance: Number.POSITIVE_INFINITY,
          font: '16px sans-serif',
          eyeOffset: new window.Cesium.Cartesian3(0, 0, 0)
        })
        drawLayerPoint.addOverlay(point)
        drawLayerPoint.addOverlay(label)
      }
      else if (args.graph.type === 'circle')
      {
        let centerPoint = [args.graph.center._lng, args.graph.center._lat]
        let circle = turf.circle(centerPoint, args.graph.radius, { steps: 128, units: 'meters', properties: { foo: 'bar' } })
        this.kjfsData.push(circle.geometry.coordinates[0])
      }
      else
      {
        let arr = []
        args.graph.positions.forEach(item =>
        {
          arr.push([item._lng, item._lat])
        })
        if (args.graph.type === 'rectangle')
          arr = this.creatteRectangle({ x: arr[0][0], y: arr[0][1] }, { x: arr[1][0], y: arr[1][1] })
        else if (args.graph.type === 'polygon')
          arr.push(arr[0])
        this.kjfsData.push(arr)
      }
      if (this.kjfsData.length > 0)
      
        this.setSearchDatas()
    },
    // 创建矩形坐标
    creatteRectangle(startPosition, endPosition)
    {
      let maxx = Math.max(endPosition.x, startPosition.x)
      let minx = Math.min(endPosition.x, startPosition.x)
      let maxy = Math.max(endPosition.y, startPosition.y)
      let miny = Math.min(endPosition.y, startPosition.y)
      let p1 = { x: minx, y: maxy }
      let p2 = { x: maxx, y: maxy }
      let p3 = { x: maxx, y: miny }
      let p4 = { x: minx, y: miny }
      return [[p1.x, p1.y], [p2.x, p2.y], [p3.x, p3.y], [p4.x, p4.y], [p1.x, p1.y]]
    },
    // 点击标准工具栏
    onMeasure(arr, index)
    {
      this.clearClick()
      this.clearDraw()
      Viewer.scene.globe.depthTestAgainstTerrain = true
      switch (arr.label)
      {
      case '点': this.$refs.label.showLP()
        break
      case '线': drawLine = new window.cxe.MeasureLine(this.viewer, this.setDrawParamsLine(arr)); drawLine.start(); this.$refs.label.closeBox(false)
        break
      case '面': drawArea = new window.cxe.MeasureArea(this.viewer, this.setDrawParamsArea(arr)); drawArea.start(); this.$refs.label.closeBox(false)
        break
      }
    },
    // 画点
    drawPoint(val)
    {
      this.delPoint()
      this.pointData = val
      let param = this.setDrawParams()
      drawPoint = new window.cxe.DrawPoint(this.viewer, param)
      drawPoint.start()
    },
    // 删除点
    delPoint()
    {
      drawLayerPoint && Viewer.layers.removeLayer(drawLayerPoint)
      drawPoint && drawPoint.destroy()
    },
    // 构造画点绘制参数
    setDrawParams(maxPos)
    {
      if (!drawLayerPoint)
      
        drawLayerPoint = new window.cxe.VectorLayer('layerpoint')
      
      Viewer.layers.addLayer(drawLayerPoint)
      let params = {
        layer: drawLayerPoint,
        drawUpdate: this.drawUpdate,
        drawFinish: this.drawFinish
      }
      if (maxPos)
        params.maxPos = maxPos
      return params
    },
    // 构造画线绘制参数
    setDrawParamsLine(maxPos)
    {
      if (!drawLayerLine)
      
        drawLayerLine = new window.cxe.VectorLayer('layerline')
      
      Viewer.layers.addLayer(drawLayerLine)
      let params = {
        layer: drawLayerLine,
        drawUpdate: this.drawUpdate,
        drawFinish: this.drawFinish
      }
      if (maxPos)
        params.maxPos = maxPos
      return params
    },
    // 构造画面绘制参数
    setDrawParamsArea(maxPos)
    {
      if (!drawLayerArea)
      
        drawLayerArea = new window.cxe.VectorLayer('layerArea')
      
      Viewer.layers.addLayer(drawLayerArea)
      let params = {
        layer: drawLayerArea,
        drawUpdate: this.drawUpdate,
        drawFinish: this.drawFinish
      }
      if (maxPos)
        params.maxPos = maxPos
      return params
    },
    // 清除交互
    clearDraw()
    {
      drawLayerPoint && Viewer.layers.removeLayer(drawLayerPoint)
      drawLayerLine && Viewer.layers.removeLayer(drawLayerLine)
      drawLayerArea && Viewer.layers.removeLayer(drawLayerArea)
    },
    // 清除方法
    clearClick()
    {
      drawPoint && drawPoint.destroy()
      drawLine && drawLine.destroy()
      drawArea && drawArea.destroy()
      Viewer.scene.globe.depthTestAgainstTerrain = false
    },
    // 工具箱点击查询功能-属性查看
    setSearchData(val)
    {
      this.searchData = []
      val.features.forEach(item =>
      {
        item.properties.rangeposition = item.geometry.coordinates[0][0]
        this.searchData.push(item.properties)
      })
      this.$refs.searchresult.setDataCon(this.searchData)
    },
    // 工具箱点击查询功能-空间分析
    setSearchDatas(val, layer)
    {
      this.searchData = []

      let coordinates = []
      this.kjfsData[0].forEach(item =>
      {
        coordinates.push(item[0] + ' ' + item[1])
      })
      let url = `https://www.camining.cn/zgis/mapserver/zgis/wms?service=wfs&version=1.0.0&request=GetFeature&typeNames=${this.layerData}&outputFormat=application/json&srsname=EPSG:4326&CQL_FILTER=INTERSECTS(the_geom,polygon((${coordinates.toString()})))`

      Axios.get(url).then(res =>
      {
        if (res.status === 200 && res.data.features.length > 0)
        {
          res.data.features.forEach(item =>
          {
            item.properties.rangeposition = item.geometry.coordinates[0][0]
            this.searchData.push(item.properties)
          })
          this.$refs.searchresult.setDataCon(this.searchData)
        }
        else
          this.$message({message: '该分析无数据', type: 'error'})
      })
    },
    // 点击属性查看
    showAtts()
    {
      this.isAtts = !this.isAtts
      let word = this.isAtts ? '属性查看已开启' : '属性查看已关闭'
      let type = this.isAtts ? 'success' : 'error'
      this.$message({message: word, type: type})
      if (handlerClick)
      {
        handlerClick.removeInputAction(window.Cesium.ScreenSpaceEventType.LEFT_CLICK)
        handlerClick = null
      }
      // this.destroyPop()
      this.CesiumEventClick(this.isAtts)
    },
    // 初始化地球左键点击事件
    CesiumEventClick(flag)
    {
      handlerClick = new window.Cesium.ScreenSpaceEventHandler(window.Viewer.scene.canvas)
      handlerClick.setInputAction(async(movement) =>
      {
        this.treeData = this.bubbleSortByProperty(this.treeData, 'showlevel')
        // 笛卡尔3坐标用于气泡窗定位
        let cart3 = this.viewer.camera.pickEllipsoid(movement.position)
        // 转经纬度
        let jwcoor = this.ompBase.screenToLng(movement.position)
        // 获取相机视图中鼠标点击位置的射线
        // let pickRay = this.viewer.camera.getPickRay(movement.position)
        let offset = 0.05
        let minx = jwcoor[0] - offset
        let miny = jwcoor[1] - offset
        let maxx = jwcoor[0] + offset
        let maxy = jwcoor[1] + offset
        let boxjw = encodeURIComponent(minx + ' ' + maxy + ',' + maxx + ' ' + maxy + ',' + maxx + ' ' + miny + ',' + minx + ' ' + miny + ',' + minx + ' ' + maxy)
        if (this.isAtts)
        {
          let status = true
          // 将经纬度坐标转换为Cartographic对象。
          let position = window.Cesium.Cartographic.fromDegrees(jwcoor[0], jwcoor[1])
          // 将地理坐标系（Cartographic）的点转换为笛卡尔坐标系（Cartesian3）中的点
          let cartesianPosition = window.Cesium.Ellipsoid.WGS84.cartographicToCartesian(position)
          // 计算两个笛卡尔坐标系（Cartesian3）中点之间的直线距离
          let distance = window.Cesium.Cartesian3.distance(Viewer.camera.position, cartesianPosition)
          this.treeData.forEach(async(item) =>
          {
            let url = `https://www.camining.cn/zgis/mapserver/zgis/wms?service=wfs&version=1.0.0&request=GetFeature&typeNames=${item.layer}&outputFormat=application/json&srsname=EPSG:4326&CQL_FILTER=INTERSECTS(the_geom,polygon((${boxjw})))`
            await Axios.get(url).then(res =>
            {
              if (res.status === 200 && res.data.features.length > 0)
              {
                if (status)
                {
                  status = false
                  this.ompPopup(cart3, res.data.features[0]['properties'], this.metadata)
                  Viewer.camera.flyTo({
                    destination: window.Cesium.Cartesian3.fromDegrees(jwcoor[0], jwcoor[1], distance),
                    duration: 3
                  })
                }
              }
            })
          })
        }
      }, window.Cesium.ScreenSpaceEventType.LEFT_CLICK)
    },
    /**
     * 构造查询参数
     * @param {Array} jwcoor  坐标
     */
    makeLyrParam(jwcoor)
    {
      let param =
      {
        layers: this.treeData,
        coordinates: jwcoor,
        crs: 'EPSG: 4326'
      }
      return param
    },
    // 处理geoserver服务点击事件
    showOneMapAtts(pos)
    {
      // 笛卡尔3坐标用于气泡窗定位
      const cart3 = this.viewer.camera.pickEllipsoid(pos)

      // 经纬度坐标用于查询geoserver服务
      let jwcoor = this.ompBase.screenToLng(pos)
      GeoQryBySvr.getAttBySvr(this.makeLyrParam(jwcoor)).then(res =>
      {
        if (res.data && res.data[0] && res.data[0][0])
          this.ompPopup(cart3)
      })
    },
    // 创建气泡弹窗
    ompPopup(pos, data, meta)
    {
      let self = this
      self.destroyPop()
      // 构造展示信息列表
      let formData = []
      Object.keys(data).forEach(item =>
      {
        formData.push({namec: item, value: data[item]})
      })
      let title = '属性信息'
      window.popups = new Popup({
        viewer: window.Viewer,
        position: pos,
        formList: formData,
        metadata: meta,
        title: title,
        closeBack: self.onClear
      })
    },
    // 销毁气泡框
    destroyPop()
    {
      if (window.popups)
      {
        window.popups.windowClose()
        window.popups = null
      }
    },
    // 清楚绘制实体
    onClear()
    {
      this.featureArr.forEach(item =>
      {
        window.Viewer.entities.remove(item)
      })
    },
    // 工具栏-搜索空间查询点击查询方式
    setMeasure(val, layerData)
    {
      this.delPos()
      this.layerData = layerData
      Viewer.viewer.scene.globe.depthTestAgainstTerrain = true
      switch (val.title)
      {
      case 'Polygon': drawPoint = new window.cxe.DrawPolygon(this.viewer, this.setDrawParams(val)); drawPoint.start(); break
      case 'Rectangle': drawLine = new window.cxe.DrawRectangle(this.viewer, this.setDrawParamsLine(val)); drawLine.start(); break
      case 'Circle': drawArea = new window.cxe.DrawCircle(this.viewer, this.setDrawParamsArea(val)); drawArea.start(); break
      }
    },
    // 定位
    positionPoint(val)
    {
      if (val.经度 && val.纬度)
      {
        let image = `static/index/map-marker1.png`

        let layer = Viewer.layers.getLayers().find(item => item.id === 'pointLayer')
        point && layer.removeOverlay(point)

        // 添加广告牌
        point = new window.cxe.Billboard({lng: val.经度, lat: val.纬度, alt: 5000}, image)
        point.size = [30, 30]
        layer.addOverlay(point)
        Viewer.camera.flyTo({
          destination: window.Cesium.Cartesian3.fromDegrees(val.经度, val.纬度, 1485110),
          duration: 4
        })
      }
      else if (val.rangeposition)
      {
        if (val.rangeposition.length === 2)
        {
          let image = `static/index/map-marker1.png`
          let layer = Viewer.layers.getLayers().find(item => item.id === 'pointLayer')
          point && layer.removeOverlay(point)
          // 添加广告牌
          point = new window.cxe.Billboard({lng: Number(val.rangeposition[0]), lat: Number(val.rangeposition[1]), alt: 5000}, image)
          point.size = [30, 30]
          layer.addOverlay(point)
          Viewer.camera.flyTo({
            destination: window.Cesium.Cartesian3.fromDegrees(Number(val.rangeposition[0]), Number(val.rangeposition[1]), 1485110),
            duration: 4
          })
        }
        else if (val.rangeposition.length > 2)
        {
          let polyPonData = []
          val.rangeposition.forEach(item =>
          {
            polyPonData.push(item)
          })
          //添加面图层
          let polylayer = Viewer.layers.getLayers().find(item => item.id === 'polygonLayer')
          polygon && polylayer.removeOverlay(polygon)

          //纯色面
          polygon = new window.cxe.Polygon(polyPonData.join(';'))
          polygon.setStyle({
            material: window.Cesium.Color.RED
          })
          polylayer.addOverlay(polygon)
          Viewer.flyTo(polylayer)
        }
        else
          this.$message({message: '该条数据无法定位', type: 'error'})
      }
    },
    // 关闭属性查看查询结果
    delPos()
    {
      let layer = Viewer.layers.getLayers().find(item => item.id === 'pointLayer')
      point && layer.removeOverlay(point)
      let polylayer = Viewer.layers.getLayers().find(item => item.id === 'polygonLayer')
      polygon && polylayer.removeOverlay(polygon)

      this.clearDraw()
      this.clearClick()
    },
    // 最小化查询结果
    minPos()
    {
      this.minIcon = true
      this.$refs.searchresult.isShow()
    },
    clickMinIcon()
    {
      this.minIcon = false
      this.$refs.searchresult.isShow()
    },
    // 获取数据共享fld表数据
    getSjgxFld()
    {
      let paras = {cmd: 'query', _major: 99, _minor: 5, _exp: 'tabname=?', types: 's', vals: 'dmcn_article_102'}
      window.post.getPost(paras).then((ret) =>
      {
        this.sjgxFld = []
        if (ret.length > 0)
        
          this.sjgxFld = ret
      })
    },
    // 获取数据共享数据
    getSjDetails(itemid)
    {
      if (itemid)
      {
        let paras = {cmd: 'query', _major: 11, _minor: 22, _exp: 'id=? and examine = 0', types: 'i', vals: itemid}
        window.post.getPost(paras).then((ret) =>
        {
          let arr = []
          arr.push({
            endataname: ret[0].endataname,
            zhdataname: ret[0].zhdataname,
            contenttype: ret[0].contenttype,
            easternlongitude: ret[0].easternlongitude,
            westlongitude: ret[0].westlongitude,
            southernlatitude: ret[0].southernlatitude,
            northlatitude: ret[0].northlatitude,
            countryname: ret[0].countryname,
            datashowmethodname: ret[0].datashowmethodname,
            scale: ret[0].scale,
            language: ret[0].language,
            dataowner: ret[0].dataowner,
            datapublishtime: ret[0].datapublishtime,
            datastorage: ret[0].datastorage,
            datasubmit: ret[0].datasubmit,
            linkman: ret[0].linkman,
            linkmethod: ret[0].linkmethod,
            filetype: ret[0].filetype,
            keyword: ret[0].keyword,
            dataserialnu: ret[0].dataserialnu,
            filesign: ret[0].filesign
          })
          this.SjgxDet = arr
          this.metadata = []
          Object.keys(this.SjgxDet[0]).forEach(item =>
          {
            this.metadata.push({namec: this.sjgxFld.filter(_ => _.colname === item)[0].namec, value: this.SjgxDet[0][item]})
          })
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/kyxxyzt/KyyztModule.vue